export default __webpack_public_path__ + "static/media/duckLogo.948fb5bc.png";